import type { Editor, EditorEvent, Events as TinyEvents } from 'hugerte';

import { isElementWrappedInCloser, isVideoElement, wrapElementInCloser } from './wrapElementInCloser';

export const onNodeChangeCallback = ({ element, target }: EditorEvent<TinyEvents.NodeChangeEvent>): void => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const editor = target as Editor;
	const images = element.tagName === 'IMG' ? [element] : Array.from(element.getElementsByTagName('IMG'));
	const iframes = element.tagName === 'IFRAME' ? [element] : Array.from(element.getElementsByTagName('IFRAME'));

	[...images, ...iframes].forEach((mediaElement) => {
		if (!isElementWrappedInCloser(mediaElement)) {
			const wrappedElement = wrapElementInCloser(mediaElement);
			mediaElement.replaceWith(wrappedElement);
			if (editor.hasFocus()) {
				const parent = wrappedElement.parentElement ?? editor.dom.getRoot();
				const wrappedIndex = Array.from(parent.childNodes).indexOf(wrappedElement);
				editor.selection.setCursorLocation(parent, wrappedIndex + 1);
				editor.execCommand('mceInsertNewLine');
			}
		}
	});
	if (isVideoElement(element)) {
		editor.selection.collapse(false);
	}
};
